const getDeliveryDateType = (text) =>
    /\w+\s\d+\w+\s-\s\w+\s\d+\w+/.test(text) ? 'range' : 'single';

export default getDeliveryDateType;
